<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
			<path
				class="light"
				fill="currentColor"
				d="M64 96C64 42.98 106.1 0 160 0C213 0 256 42.98 256 96V352C256 387.3 227.3 416 192 416C156.7 416 128 387.3 128 352V144C128 135.2 135.2 128 144 128C152.8 128 160 135.2 160 144V352C160 369.7 174.3 384 192 384C209.7 384 224 369.7 224 352V96C224 60.65 195.3 32 160 32C124.7 32 96 60.65 96 96V384C96 437 138.1 480 192 480C245 480 288 437 288 384V144C288 135.2 295.2 128 304 128C312.8 128 320 135.2 320 144V384C320 454.7 262.7 512 192 512C121.3 512 64 454.7 64 384V96z"
			/>
			<path
				class="regular"
				fill="currentColor"
				d="M48 108C48 48.35 96.35 0 156 0C215.6 0 264 48.35 264 108V344C264 383.8 231.8 416 192 416C152.2 416 120 383.8 120 344V152C120 138.7 130.7 128 144 128C157.3 128 168 138.7 168 152V344C168 357.3 178.7 368 192 368C205.3 368 216 357.3 216 344V108C216 74.86 189.1 48 156 48C122.9 48 96 74.86 96 108V368C96 421 138.1 464 192 464C245 464 288 421 288 368V152C288 138.7 298.7 128 312 128C325.3 128 336 138.7 336 152V368C336 447.5 271.5 512 192 512C112.5 512 48 447.5 48 368V108z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'PaperclipVerticalIcon',
	components: { Icon },
	props,
}
</script>
